import axios from 'axios'

//  获取账户中心字典
export function userDic() {
  return axios.get('party/v1/account/center/term?')
}

//  获取回访字典
export function visitDic() {
  return axios.get('party/v1/policy/return/visit/type?')
}



// WEBPACK FOOTER //
// ./src/interface.js